import React, { useEffect, useState } from "react";
import axios from "axios";
import { getBaseUrl, loadStorage } from "../../Utils/Utils";

const STATES = ["Delhi","Uttar Pradesh","Haryana","Punjab","Himachal Pradesh","Rajasthan","Uttarakhand"];

const empty = { FullName: '', Phone: '', AddressLine: '', Locality: '', State: '', Pincode: '', IsDefault: false };

function Addresses() {
    const [addresses, setAddresses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showForm, setShowForm] = useState(false);
    const [editId, setEditId] = useState(null);
    const [form, setForm] = useState(empty);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');

    const headers = () => ({ Authorization: `Bearer ${loadStorage("token")}` });

    const fetchAddresses = () => {
        axios.get(`${getBaseUrl()}/address`, { headers: headers() })
            .then(res => setAddresses(res.data))
            .catch(() => {})
            .finally(() => setLoading(false));
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { fetchAddresses(); }, []);

    const openAdd = () => { setForm(empty); setEditId(null); setError(''); setShowForm(true); };
    const openEdit = (addr) => { setForm({ ...addr, AddressLine: addr.addressLine, FullName: addr.fullName, IsDefault: addr.isDefault }); setEditId(addr.id); setError(''); setShowForm(true); };
    const cancel = () => { setShowForm(false); setEditId(null); setError(''); };

    const save = async (e) => {
        e.preventDefault();
        if (!form.FullName || !form.Phone || !form.AddressLine || !form.Locality || !form.State || !form.Pincode) {
            setError('All fields are required.'); return;
        }
        setSaving(true);
        try {
            if (editId) {
                await axios.put(`${getBaseUrl()}/address/${editId}`, form, { headers: headers() });
            } else {
                await axios.post(`${getBaseUrl()}/address`, form, { headers: headers() });
            }
            await fetchAddresses();
            setShowForm(false);
            setEditId(null);
        } catch { setError('Failed to save address.'); }
        finally { setSaving(false); }
    };

    const remove = async (id) => {
        if (!window.confirm('Delete this address?')) return;
        await axios.delete(`${getBaseUrl()}/address/${id}`, { headers: headers() });
        setAddresses(prev => prev.filter(a => a.id !== id));
    };

    const setDefault = async (id) => {
        await axios.put(`${getBaseUrl()}/address/${id}/default`, {}, { headers: headers() });
        setAddresses(prev => prev.map(a => ({ ...a, isDefault: a.id === id })));
    };

    return (
        <div className="col-lg-8 col-md-8 col-12">
            <div className="ml-0 ml-md-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0 text-white">Saved Addresses</h5>
                    {!showForm && (
                        <button className="btn btn-primary btn-sm" onClick={openAdd}>
                            <i className="ti-plus"></i> Add New
                        </button>
                    )}
                </div>

                {showForm && (
                    <div className="card mb-3">
                        <div className="card-body">
                            <h6 className="mb-3">{editId ? 'Edit Address' : 'Add New Address'}</h6>
                            {error && <div className="alert alert-danger py-2">{error}</div>}
                            <form onSubmit={save}>
                                <div className="row">
                                    <div className="col-sm-6 mb-3">
                                        <input className="form-control" placeholder="Full Name *" value={form.FullName} onChange={e => setForm(f => ({ ...f, FullName: e.target.value }))} />
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <input className="form-control" placeholder="Phone *" value={form.Phone} onChange={e => setForm(f => ({ ...f, Phone: e.target.value }))} />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <input className="form-control" placeholder="Address (House No, Building, Street) *" value={form.AddressLine} onChange={e => setForm(f => ({ ...f, AddressLine: e.target.value }))} />
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <input className="form-control" placeholder="Locality / Town *" value={form.Locality} onChange={e => setForm(f => ({ ...f, Locality: e.target.value }))} />
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <select className="form-control" value={form.State} onChange={e => setForm(f => ({ ...f, State: e.target.value }))}>
                                            <option value="">Select State *</option>
                                            {STATES.map(s => <option key={s} value={s}>{s}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-sm-6 mb-3">
                                        <input className="form-control" placeholder="Pincode *" value={form.Pincode} onChange={e => setForm(f => ({ ...f, Pincode: e.target.value }))} />
                                    </div>
                                    <div className="col-sm-6 mb-3 d-flex align-items-center">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id="isDefault" checked={form.IsDefault} onChange={e => setForm(f => ({ ...f, IsDefault: e.target.checked }))} />
                                            <label className="form-check-label" htmlFor="isDefault">Set as default address</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-primary btn-sm" type="submit" disabled={saving}>
                                        {saving ? 'Saving...' : 'Save Address'}
                                    </button>
                                    <button className="btn btn-secondary btn-sm" type="button" onClick={cancel}>Cancel</button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {loading && <p className="text-white">Loading...</p>}
                {!loading && addresses.length === 0 && !showForm && (
                    <div className="card">
                        <div className="card-body text-muted text-center py-4">
                            No saved addresses. Click "Add New" to add one.
                        </div>
                    </div>
                )}

                <div className="row">
                    {addresses.map(addr => (
                        <div className="col-md-6 mb-3" key={addr.id}>
                            <div className={`card h-100 ${addr.isDefault ? 'border-primary' : ''}`}>
                                <div className="card-body p-3">
                                    {addr.isDefault && <span className="badge bg-primary mb-2">Default</span>}
                                    <p className="mb-1 font-weight-bold">{addr.fullName}</p>
                                    <p className="mb-1 small">{addr.addressLine}, {addr.locality}</p>
                                    <p className="mb-1 small">{addr.state} - {addr.pincode}</p>
                                    <p className="mb-2 small text-muted">{addr.phone}</p>
                                    <div className="d-flex gap-2 flex-wrap">
                                        <button className="btn btn-sm btn-outline-primary" onClick={() => openEdit(addr)}>Edit</button>
                                        <button className="btn btn-sm btn-outline-danger" onClick={() => remove(addr.id)}>Delete</button>
                                        {!addr.isDefault && (
                                            <button className="btn btn-sm btn-outline-secondary" onClick={() => setDefault(addr.id)}>Set Default</button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Addresses;
